import {
  markPerf,
  measureFirstMarket,
  measureFullDetailLoaded,
} from './sportsnewPerf.js';

const MARKET_CHUNK_SIZE = 6;

export const renderSportsnewDetailMarketsProgressively = ({
  request,
  markets,
  measureFromClick,
  marketChunkRafRef,
  latestDetailRequestRef,
  commitDetailMarkets,
}) => {
  const fixtureId = request.fixtureId;
  if (marketChunkRafRef.current) {
    cancelAnimationFrame(marketChunkRafRef.current);
    marketChunkRafRef.current = null;
  }

  if (markets.length <= MARKET_CHUNK_SIZE) {
    commitDetailMarkets(markets);
    if (measureFromClick) {
      markPerf(`sportsnew:first_market:${fixtureId}`); measureFirstMarket(fixtureId);
      markPerf(`sportsnew:full_detail:${fixtureId}`); measureFullDetailLoaded(fixtureId);
    }
    return;
  }

  let renderedCount = 0;
  const pushChunk = () => {
    if (latestDetailRequestRef.current !== request) {
      marketChunkRafRef.current = null;
      return;
    }

    renderedCount += MARKET_CHUNK_SIZE;
    commitDetailMarkets(markets.slice(0, renderedCount));
    if (renderedCount <= MARKET_CHUNK_SIZE && measureFromClick) {
      markPerf(`sportsnew:first_market:${fixtureId}`); measureFirstMarket(fixtureId);
    }

    if (renderedCount < markets.length) {
      marketChunkRafRef.current = requestAnimationFrame(pushChunk);
      return;
    }
    marketChunkRafRef.current = null;
    if (measureFromClick) {
      markPerf(`sportsnew:full_detail:${fixtureId}`); measureFullDetailLoaded(fixtureId);
    }
  };
  pushChunk();
};
